import React, { useEffect, useRef } from 'react';
import ReactDom from 'react-dom';
import { CSSTransition } from 'react-transition-group';

import Backdrop from './Backdrop';
import Icon from './Icon';
import './Modal.css';

const ModalOverlay = (props) => {
  const dialogRef = useRef(null);
  const cancelRef = useRef(props.onCancel);
  cancelRef.current = props.onCancel;
  useEffect(() => {
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const dialog = dialogRef.current;
    const selector =
      'button:not([disabled]), a[href], input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex="0"]';
    const firstControl = dialog.querySelector(selector);
    (firstControl || dialog).focus();
    const handleKey = (event) => {
      if (event.key === 'Escape') {
        event.stopPropagation();
        if (cancelRef.current) cancelRef.current();
      }
      if (event.key !== 'Tab') return;
      const controls = Array.from(dialog.querySelectorAll(selector));
      if (!controls.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }
      const first = controls[0],
        last = controls[controls.length - 1];
      if (
        event.shiftKey &&
        (document.activeElement === first || document.activeElement === dialog)
      ) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    dialog.addEventListener('keydown', handleKey);
    return () => {
      dialog.removeEventListener('keydown', handleKey);
      document.body.style.overflow = previousOverflow;
      if (previousFocus && previousFocus.isConnected) previousFocus.focus();
    };
  }, []);
  const Content = (
    <div
      ref={dialogRef}
      role="dialog"
      aria-modal="true"
      aria-label={props.header || 'Dialog'}
      tabIndex="-1"
      className={`modal ${props.className || ''}`}
      style={props.style}
    >
      <header className={`modal__header ${props.headerClass}`}>
        <button
          type="button"
          className="modal-back"
          onClick={props.onCancel}
          aria-label="Back to previous window"
        >
          <Icon name="back" size={17} />
          Back
        </button>
        <h2>{props.header}</h2>
      </header>
      <form onSubmit={props.onSubmit ? props.onSubmit : (event) => event.preventDefault()}>
        <div className={`modal__content ${props.contentClass}`}>{props.children}</div>
        <footer className={`modal__footer ${props.footerClass}`}>{props.footer}</footer>
      </form>
    </div>
  );

  return ReactDom.createPortal(Content, document.getElementById('modal-hook'));
};

const Modal = (props) => {
  return (
    <React.Fragment>
      {props.show && <Backdrop onClick={props.onCancel} />}
      <CSSTransition in={props.show} mountOnEnter unmountOnExit timeout={200} classNames="modal">
        <ModalOverlay {...props} />
      </CSSTransition>
    </React.Fragment>
  );
};

export default Modal;
